"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxCertificateInfoResults = void 0;
function deserializeHxCertificateInfoResults(values) {
    var i = 0;
    var displayName = values[i++];
    var emailAddress = values[i++];
    var SubjectAlternativeNameAddressesValues = values[i++];
    var SubjectAlternativeNameAddresses = new Array(SubjectAlternativeNameAddressesValues.length);
    for (var index = 0; index < SubjectAlternativeNameAddressesValues.length; index++) {
        SubjectAlternativeNameAddresses[index] = SubjectAlternativeNameAddressesValues[index];
    }
    var subject = values[i++];
    var issuer = values[i++];
    var serialNumber = values[i++];
    var certificateUsage = values[i++];
    var notValidBefore = values[i++];
    var notValidAfter = values[i++];
    var validationStatus = values[i++];
    var certificate = values[i++];
    var certificateHash = values[i++];
    i++; // ignore certificateAlias
    i++; // ignore keyChainAccessGroupName
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { displayName: displayName, emailAddress: emailAddress, SubjectAlternativeNameAddresses: SubjectAlternativeNameAddresses, subject: subject, issuer: issuer, serialNumber: serialNumber, certificateUsage: certificateUsage, notValidBefore: notValidBefore, notValidAfter: notValidAfter, validationStatus: validationStatus, certificate: certificate, certificateHash: certificateHash };
}
exports.deserializeHxCertificateInfoResults = deserializeHxCertificateInfoResults;
